import { Expose, plainToInstance, Transform } from "class-transformer";
import { IsDate, IsEnum, IsInt, IsOptional } from "class-validator";
import { OnboardingStepType } from "./onboarding-step-type.enum";

export class UpdateDesignProjectOnboardingStepDto {
  public static from(onboardingStep: any) {
    return plainToInstance(
      UpdateDesignProjectOnboardingStepDto,
      onboardingStep,
      {
        excludeExtraneousValues: true,
      },
    );
  }
  @Expose()
  @IsEnum(OnboardingStepType)
  stepType!: OnboardingStepType;

  @Expose()
  @IsInt()
  @IsOptional()
  position?: number;

  @Expose()
  @IsInt()
  @IsOptional()
  stage?: number;

  @Expose()
  @IsInt()
  @IsOptional()
  percentComplete?: number;
}
